import { render, staticRenderFns } from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=template&id=a368ee04&scoped=true&"
import script from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialGlobalSuitability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a368ee04",
  null
  
)

export default component.exports